import './DropDownMenu.css'
import * as React from "react"

export default function Component(props){
    const select=(item,index)=>()=>{
        if(props.select)props.select(item,index)
    }
    return(
        <div className='relative dropdown_main select-none cursor-pointer text-white text-[14px]'>
            <div className="hover:bg-[#ddd] flex flex-row items-center gap-[8px] px-[16px] py-[8px] rounded-[7px] border pointer-cursor justify-between" style={{width:props.isFullWidth?'100%':'auto',minWidth:props.minWidth||180,border:'.5px solid #00000080',color:'black'}}> 
                {props.value}
                <ArrowSvg/>
            </div>
            <div className='absolute top-[100%] left-0 dropdown_main_expand flex-col bg-white w-full gap-[4px] rounded-[4px] border border-[#aaa] max-h-[200px]' style={{overflowY:'auto', zIndex:999}}>
                {(props.options||[]).map((item,index)=>
                    <div key={index} onClick={select(item,index)} className='px-[16px] py-[4px] hover:text-white hover:bg-[#ddd] cursor-pointer' style={{color:'black'}}> {item}</div>
                )}
            </div>
        </div>
    )
}



const ArrowSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#212121"
        d="m6.333 7.343 3.825 3.817 3.825-3.817 1.175 1.175-5 5-5-5 1.175-1.175Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.158.185h20v20h-20z" />
      </clipPath>
    </defs>
  </svg>
)
